/* eslint-disable */
import { Button, Grid, IconButton, Snackbar, Typography } from '@material-ui/core';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { withStyles } from '@material-ui/core/styles';
import withWidth from '@material-ui/core/withWidth';
import AddCommentIcon from '@material-ui/icons/AddComment';
import CloseIcon from '@material-ui/icons/Close';
import ErrorIcon from '@material-ui/icons/Error';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';
import cn from 'classnames';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { bindActionCreators } from 'redux';
import { ORDER_API_DATE_FORMAT } from '../../Constants/Order/Order.constants';
import withServices from '../../Contexts/Services/WithServices.context';
import ThemeStatePropTypes from '../../State/Store/Theme/Theme.props';
import uiActionCreators from '../../State/Store/UI/UI.actions';
import { UI_DOCKET_ACCEPT_ATTEMPT, UI_DOCKET_MODAL_REPORT_ISSUE, UI_DOCKET_OPEN_ADD_NOTE, UI_DOCKET_MODAL_DOWNLOAD_PDF_BUTTON_CLICK } from '../../State/Store/UI/UI.types';
import userProfileSelector from '../../State/Store/UserProfile/Selectors/UserProfileCurrent.selector';
import dateOnly from '../../Support/DateTime/DateOnly/DateTimeDateOnly.support';
import DeliveryDocketPdf from '../../Support/Generators/DeliveryDocketPdf/DeliveryDocketPdf';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import Modal from '../Modal/Modal.component';
import Spinner from '../Spinner/Spinner.component';
import DeliveryDocket from './DeliveryDocket.component';
import deliveryDocketStyles from './DeliveryDocket.component.styles';
import DeliveryDocketAddNote from './DeliveryDocketAddNote.component';
import DeliveryDocketReportIssue from './DeliveryDocketReportIssue.component';
import Hidden from '@material-ui/core/Hidden';

/**
 * DeliveryDocket
 * @param {any} props The props
 * @returns {React.Component} The component
 */
const DeliveryDocketModal = ({ userInfo, actions, onDocketAcceptChange, currentDocket, onCloseDetails, open, services, classes, docket, currentAccount }) => {
  const [showConfirmAccept, setShowConfirmAccept] = useState(false);
  const [showOptions, setShowOptions] = useState(null);
  const [showReportAnIssue, setShowReportAnIssue] = useState(false);
  const [activities, setActivities] = useState([]);
  const [error, setError] = useState(false);
  const [isAccepting, setIsAccepting] = useState(false);
  const [docketDetails, setDocketDetails] = useState({});
  const [showActivitiesTab, setShowActivitiesTab] = useState(0);
  const [showAddNote, setShowAddNote] = useState(false);

  /**
   * Checks if user viewed docket already
   * @param {userId} userId to search for in activities
   * @param {Array} allActivities array of activities
   * @returns {boolean} true if user already is in viewed activities
   * @memberof DeliveryDocketModal
   */
  const userViewedDocketAlready = (userId, allActivities) => {
    return allActivities.find((activity) => activity.userId === userId && activity.type === `DOCKET_VIEWED`);
  };

  /**
   * Opens Add a Note dialog
   * @returns {void} void
   * @memberof DeliveryDocketModal
   */
  const addNote = () => {
    actions.uiTriggered({
      payload: {
        data: {
          name: `docketOpenAddNote`,
        },
      },
      type: UI_DOCKET_OPEN_ADD_NOTE,
    });

    setShowAddNote(true);
    return;
  };

  /**
   * Loads docket details
   * @param {Object} requiredDocket Ticket code of the docket
   * @returns {void} void
   * @memberof DeliveryDocketModal
   */
  const loadDocketDetails = async (requiredDocket) => {
    const date = dateOnly(requiredDocket.orderDate, ORDER_API_DATE_FORMAT);
    const orderCode = requiredDocket.orderCode.trim();
    const docketNumber = requiredDocket.docketNumber.trim();
    const requestPayload = {
      date,
      orderCode,
      orderLine: requiredDocket.orderLine,
      ticketCode: requiredDocket.docketNumber,
    };

    try {
      const { id: userId } = userInfo;
      const docketId = `${date}-${orderCode}-${docketNumber}`;
      setDocketDetails(await services.orderService.getDeliveryDocket(requestPayload));
      const allActivities = await services.docketService.getActivities({ docketId });
      setActivities(allActivities);
      if (!userViewedDocketAlready(userId, allActivities)) {
        await services.docketService.markViewed({ docketId, userId });
      }
    } catch (ex) {
      setDocketDetails({ error: true });
    }
    return;
  };

  /**
   * Refreshes list of activitiest
   * @returns {Object} allActivities updated activities
   * @memberof DeliveryDocketModal
   */
  const onRefreshActivities = async () => {
    const date = dateOnly(currentDocket.orderDate, ORDER_API_DATE_FORMAT);
    const orderCode = currentDocket.orderCode.trim();
    const docketNumber = currentDocket.docketNumber.trim();

    const docketId = `${date}-${orderCode}-${docketNumber}`;
    const allActivities = await services.docketService.getActivities({ docketId });
    setActivities(allActivities);
    return allActivities;
  };

  useEffect(() => {
    if (currentDocket) {
      setActivities([]);
      loadDocketDetails(currentDocket);
    }
  }, [currentDocket]);

  /**
   * Shows kebab options
   * @param {Object} target dom element to be used as anchor
   * @returns {void} void
   * @memberof DeliveryDocketModal
   */
  const showOptionsMenu = (target) => {
    setShowOptions(target);
    return;
  };

  /**
   * Shows accept confirmation
   * @returns {void} void
   * @memberof DeliveryDocketModal
   */
  const showAcceptConfirmation = () => {
    setShowConfirmAccept(true);
    showOptionsMenu(false);
    return;
  };

  /**
   * Hides accept confirmation
   * @returns {void} void
   * @memberof DeliveryDocketModal
   */
  const hideAcceptConfirmation = () => {
    setShowConfirmAccept(false);
    return;
  };

  /**
   * Hides kebab options
   * @returns {void} void
   * @memberof DeliveryDocketModal
   */
  const hideOptionsMenu = () => {
    setShowOptions(null);
    return;
  };

  /**
   * Downloads docket
   * @returns {void} void
   * @memberof DeliveryDocketModal
   */
  const downloadDocket = async () => {
    if (!currentAccount) {
      return;
    }
    showOptionsMenu(false);
    const requestPayload = {
      date: dateOnly(currentDocket.orderDate, ORDER_API_DATE_FORMAT),
      orderCode: currentDocket.orderCode.trim(),
      orderLine: currentDocket.orderLine,
      ticketCode: currentDocket.docketNumber,
    };

    actions.uiTriggered({
      payload: {
        data: {
          name: `docketModalDownloadPdfButtonClick`,
        },
      },
      type: UI_DOCKET_MODAL_DOWNLOAD_PDF_BUTTON_CLICK,
    });

    try {
      const result = await services.docketService.getDocketPDFContentSingle({
        ...requestPayload,
        account: currentAccount,
      });
      DeliveryDocketPdf({
        ...result.response,
        docketId: currentDocket.docketNumber,
      });
    } catch (e) {
      //
    }
    // DeliveryDocketPdf({ ...docketDetails, docketId: currentDocket.docketNumber });
    // return;
  };

  /**
   * Opens Report an issue dialog
   * @returns {void} void
   * @memberof DocketsList
   */
   const reportAnIssue = () => {
    actions.uiTriggered({
      payload: {
        data: {
          name: `docketModalReportIssue`,
          phoneNumber: docketDetails.callBoral,
        },
      },
      type: UI_DOCKET_MODAL_REPORT_ISSUE,
    });
    setShowOptions(null);
    setShowReportAnIssue(true);
    return;
  };

  /**
   * Attempts to accept docket
   * @returns {void} void
   * @memberof DeliveryDocketModal
   */
  const acceptDocket = async () => {
    actions.uiTriggered({
      payload: {
        data: {
          name: `docketAcceptAttempt`,
          value: !docketDetails.accepted,
        },
      },
      type: UI_DOCKET_ACCEPT_ATTEMPT,
    });
    setIsAccepting(true);
    const docketId = `${dateOnly(docketDetails.ticketDate, ORDER_API_DATE_FORMAT)}-${currentDocket.orderCode.trim()}-${currentDocket.docketNumber.trim()}`;
    try {
      await services.docketService.acceptDocket({ docketId, accepted: !docketDetails.accepted });
      setShowConfirmAccept(false);
      setActivities(await services.docketService.getActivities({ docketId }));
      setDocketDetails({ ...docketDetails, accepted: !docketDetails.accepted });
      if (onDocketAcceptChange) {
        onDocketAcceptChange();
      }
      setIsAccepting(false);
    } catch (ex) {
      setError(true);
      setIsAccepting(false);
    }
    return;
  };

  /**
   * refreshes activities, highlights latest note and shows activities tab
   * @returns {void} void
   * @memberof DeliveryDocketModal
   */
  const onNoteAdded = async () => {
    const updatedActivities = await onRefreshActivities();
    updatedActivities[0].isHighlighted = true;
    setShowActivitiesTab(1);
  };

  /**
   * Unhighlights all activities
   * @returns {void} void
   * @memberof DeliveryDocketModal
   */
  const unhighlightActivities = () => {
    setActivities(activities.map((activity) => ({ ...activity, isHighlighted: false })));
    return;
  };

  /**
   * Closes the modal and resets
   * @returns {void} void
   * @memberof DeliveryDocketModal
   */
  const onModalClose = () => {
    unhighlightActivities();
    setShowActivitiesTab(0);
    onCloseDetails();
    return;
  };

  /**
   * Closes the modal and resets
   * @param {number} tab Tab index
   * @returns {void} void
   * @memberof DeliveryDocketModal
   */
  const onChangeTabHandler = (tab) => {
    if (!tab) {
      unhighlightActivities();
    }
    setShowActivitiesTab(tab);
    return;
  };

  return (
    <React.Fragment>
      <Snackbar
        action={[
          <IconButton aria-label="Close" className={classes.close} color="inherit" key="close" onClick={() => setError(false)}>
            <CloseIcon />
          </IconButton>,
        ]}
        anchorOrigin={{
          horizontal: `left`,
          vertical: `bottom`,
        }}
        className={classes.snackbar}
        ContentProps={{ classes: { root: classes.error } }}
        message={
          <span className={classes.snackbarMessage} id="client-snackbar">
            <ErrorIcon className={classes.snackbarIcon} />
            An error has occurred. Please try again later.
          </span>
        }
        open={error}
      />
      <DeliveryDocketAddNote
        docket={{ ...currentDocket, ticketDate: docketDetails.ticketDate }}
        onAdd={onNoteAdded}
        open={!!showAddNote}
        onClose={() => setShowAddNote(false)}
      />

      <DeliveryDocketReportIssue
        phoneNumber={docketDetails.callBoral}
        open={showReportAnIssue}
        onClose={() => setShowReportAnIssue(false)}
        isReporting={false}
      />
      <Modal
        content={
          <DeliveryDocket
            onError={() => setError(true)}
            onUnaccept={showAcceptConfirmation}
            docket={{ ...docketDetails, ...currentDocket, accepted: docketDetails.accepted }}
            activities={activities}
            onRefreshActivities={onRefreshActivities}
            selectedTab={showActivitiesTab}
            // when user switches tabs to 1 (docket) then unhighlight all activities as these been already seen by user
            onChangeTab={onChangeTabHandler}
          />
        }
        onClose={onModalClose}
        open={!!open}
        rightHeading={
          <Grid container justify="flex-end">
            {!docketDetails.error && (
              <Grid item className={classes.iconHolder}>
                <Hidden smDown>
                  <Button aria-label="Menu" color="inherit" edge="start" onClick={downloadDocket} className={cn(classes.iconLeft)}>
                    <PictureAsPdfIcon className={classes.iconLeft}/>Download PDF
                  </Button>
                </Hidden>
                <Hidden mdUp>
                  <IconButton aria-label="Menu" color="inherit" edge="start" onClick={downloadDocket} className={cn(classes.iconLeft)}>
                    <PictureAsPdfIcon />
                  </IconButton>
                </Hidden>
                <IconButton aria-label="Menu" color="inherit" edge="start" onClick={(e) => showOptionsMenu(e.currentTarget)}>
                  <MoreVertIcon />
                </IconButton>
                {showOptions && (
                  <Menu anchorEl={showOptions} onClose={hideOptionsMenu} open={!!showOptions}>
                    <MenuItem onClick={showAcceptConfirmation}>
                      <PlaylistAddCheckIcon className={cn(classes.iconLeft, docketDetails.accepted ? classes.accepted : ``)} />
                      Mark as {docketDetails.accepted ? `Unaccepted` : `Accepted`}
                    </MenuItem>
                    <MenuItem onClick={(e) => addNote(e.currentTarget)}>
                      <AddCommentIcon className={cn(classes.iconLeft)} />
                      Add Note
                    </MenuItem>
                    <MenuItem onClick={reportAnIssue}>
                      <ErrorIcon className={cn(classes.iconLeft)} />
                      Report an issue
                    </MenuItem>
                  </Menu>
                )}
              </Grid>
            )}
          </Grid>
        }
        maxWidth="sm"
        title={
          <Grid container>
            <Grid item xs={12}>
              Docket #{currentDocket.docketNumber}
            </Grid>
          </Grid>
        }
      />
      <Modal
        content={
          <Typography variant="body1">
            {docketDetails.accepted
              ? `This docket has already been marked as accepted. Would you like to undo this?`
              : `When you mark this docket as accepted, you and your team will be able to see this in the docket activity.`}
          </Typography>
        }
        footer={
          isAccepting ? (
            <Grid container justify="flex-end">
              <Grid item>
                <Spinner size={20} loaderStyles={classes.spinner} />
              </Grid>
            </Grid>
          ) : (
            <Grid className={classes.textAlignRight} container justify="flex-end" spacing={2}>
              <Grid className={classes.flexGrow1} item>
                <Button className={classes.button} color="primary" disabled={isAccepting} onClick={acceptDocket} variant="contained">
                  {docketDetails.accepted ? `UNDO` : `OK`}
                </Button>
              </Grid>
              <Grid item>
                <Button className={classes.button} color="primary" disabled={isAccepting} onClick={hideAcceptConfirmation} variant="outlined">
                  {docketDetails.accepted ? `CLOSE` : `CANCEL`}
                </Button>
              </Grid>
            </Grid>
          )
        }
        paperClasses={classes.paperClasses}
        maxWidth="sm"
        icon={<PlaylistAddCheckIcon />}
        preventFullScreen
        onClose={hideAcceptConfirmation}
        open={!!showConfirmAccept}
        rightHeading={null}
        title={
          <Grid container>
            <Grid item xs={12}>
              {docketDetails.accepted ? `Docket Accepted` : `Mark as Accepted`}
            </Grid>
          </Grid>
        }
      />
    </React.Fragment>
  );
};

/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/require-default-props */
DeliveryDocketModal.propTypes = {
  userInfo: PropTypes.object.isRequired,
  classes: ThemeStatePropTypes.classes.isRequired,
  actions: PropTypes.object.isRequired,
  currentDocket: PropTypes.any.isRequired,
  onCloseDetails: PropTypes.func.isRequired,
  onDocketAcceptChange: PropTypes.func,
  open: PropTypes.any.isRequired,
  services: PropTypes.object.isRequired,
  docket: PropTypes.string,
};

export default compose(
  withWidth(),
  withServices,
  connect(
    (state) => ({
      listSettings: state.dockets ? state.dockets.listSettings : null,
      userInfo: userProfileSelector(state),
    }),
    (dispatch) => ({
      actions: bindActionCreators(
        {
          ...uiActionCreators,
        },
        dispatch,
      ),
    }),
  ),
  withStyles(themeCreateInjectableStyles(deliveryDocketStyles), { withTheme: true }),
)(DeliveryDocketModal);
